import Vue from "vue";

export const state = Vue.observable({
  metadata: {},
  documentsToUpload: [],
  editMode: false,
  activeOverlay: false
});

export const mutations = {
  setMetadata: (metadata) => {
    state.metadata = metadata
  },
  deleteDocument: index => {
    state.documentsToUpload.splice(index, 1);
  },
  addDocument: (document) => {
    state.documentsToUpload.push(document)
  },
  setEditMode: value => {
    state.editMode = value
  },
  setActiveOverlay: value => {
    state.activeOverlay = value
  },
  cleanAllDocuments: () => {
    state.documentsToUpload = []
  }
}